import PropTypes from 'prop-types';
import React, { Component } from 'react';
import utilities from './../../../utils/utilities';
import SearchBox from '../../SearchBox/SearchBox.selectableTable';
import CountBox from '../../CountBox/CountBox.index';
import { FILTER_TYPE_DROPDOWN } from './../../../constants';
import { NoResultsModal, DropdownFilter } from "./../Components";
import Spinner from "../../Spinner/Spinner";

export default function withSearch(CollectionComponent) {
    class Searchable extends Component {
        static propTypes = {
            searchTerm: PropTypes.string,
            onSearchTermChange: PropTypes.func.isRequired,
            filters: PropTypes.array
        }

        static defaultProps = {
            searchTerm: ""
        }

        constructor(props) {
            super(props);

            this.state = {
                noResultsModalVisible: false
            }
            
            this.loadItems = this.loadItems.bind(this);
            this.handleSearch = this.handleSearch.bind(this);
            this.resetFilter = this.resetFilter.bind(this);
            this.handleCloseNoResultsModal = this.handleCloseNoResultsModal.bind(this);
        }

        /**
         * Wraps loadItems from the composed chain of HOCs, adds filter parameter
         * @param params
         */
        loadItems(params = null) {
            let newParams = {};
            if (params) {
                newParams = params;
            }
            if (!newParams.filters) {
                newParams.filters = {}
            }

            return this.props.loadItems(newParams).then(results => {
                if (this.areActiveFilters() && results.length === 0 && this.props.searchTerm.trim().length > 0) {
                    this.setState({ noResultsModalVisible: true })
                }
            });
        }

        areActiveFilters() {
            let areActiveFilters = false;
            if (this.props.searchTerm.trim().length > 0) {
                areActiveFilters = true;
            }
            this.props.filters && this.props.filters.forEach(filter => {
               if (filter.value !== filter.default) {
                   areActiveFilters = true;
               }
            });
            return areActiveFilters;
        }

        /**
         * Sets query term in state, calls load items with
         * @param query
         */
        handleSearch(searchTerm) {
            this.loadItems({ filters: { query: searchTerm.trim() }, reset: true, pagination: { pageNumber: 0 }});
        }

        handleCloseNoResultsModal() {
            this.setState({ noResultsModalVisible: false });
            this.resetFilter();
        }

        /**
         * Handles reset search and filters
         */
        resetFilter() {
            if (this.props.filters) {
                let filters = {}
                this.props.filters.forEach(filter => {
                    filters[filter.field] = filter.default;
                    if (filter.onChange) {
                        filter.onChange(filter.default);
                    }
                });
                filters.query = "";
                this.loadItems({ filters , reset: true, pagination: { pageNumber: 0 } })
            } else {
                this.handleSearch("");
            }
        }

        /**
         * Iterates and displays filters
         * @returns {*}
         */
        renderFilters() {
            return this.props.filters ?
                <div className="searchable-filters">{this.props.filters.map(filter => this.renderFilter(filter))}</div> : null
        }

        /**
         * Renders individual filter
         * @param filter
         * @returns {XML}
         */
        renderFilter(filter) {
            // TODO: Add filter types as needed below
            switch (filter.type) {
                case FILTER_TYPE_DROPDOWN:
                    return <DropdownFilter filter={filter} onChange={this.applyFilter(filter)} key={filter.field}/>
                default:
                    return <DropdownFilter filter={filter} onChange={this.applyFilter(filter)} key={filter.field}/>
            }
        }

        applyFilter = (filter) => (e) => {
            this.loadItems({ filters: {[filter.field] : e.target.value }, reset: true, pagination: { pageNumber: 0 } })
            if (filter.onChange) {
                filter.onChange(e.target.value);
            }
        }


        render() {
            return <div className={this.props.filters ? "with-filters" : null}>
                <SearchBox handleSearch={this.handleSearch} initialValue={this.props.searchTerm} />
                { this.renderFilters() }
                {!this.props.hasError &&
                    <Spinner isLoading={this.props.filterCount === null} tiny className={"count-box-spinner"}>
                        <CountBox totalCount={this.props.totalCount ? this.props.totalCount : this.props.itemCount}
                                  partialCount={this.props.filterCount}
                                  showAll={this.resetFilter}/>
                    </Spinner>
                }
                <CollectionComponent {...this.props}
                                     loadItems={this.loadItems}
                                     totalCount={this.props.filterCount} />
                { (this.state.noResultsModalVisible) &&
                <NoResultsModal term={this.props.searchTerm} onClose={this.handleCloseNoResultsModal}/>}
            </div>
        }
    }

    Searchable.displayName = `Searchable(${utilities.getDisplayName(CollectionComponent)})`;
    return Searchable;
}


// WEBPACK FOOTER //
// ./src/scripts/reusable/LightTable/hoc/Searchable.jsx